import classNames from 'classnames';
import { useCycleIndex } from '../useCycleIndex';
import css from './WorkspaceHero.module.scss';

// Things an Agent actually does, so the headline doubles as the capability list. Mirrors the
// landing hero's "Cut down, clip, reframe, caption, find the moment, generate what's missing".
const AGENT_ASKS = [
  'clip your podcast.',
  'find the moment.',
  'reframe it for TikTok.',
  'caption every word.',
  'cut it down to a minute.',
  "generate what's missing.",
];

const ASK_INTERVAL_MS = 2800;

/** What StarZero does, in one sentence. The cards below it are the ways in. */
export const WorkspaceHero = () => {
  const askIndex = useCycleIndex(AGENT_ASKS.length, ASK_INTERVAL_MS);

  return (
    <section className={css.hero}>
      <h1 className={css.headline}>
        <span className={css.headlineLead}>Ask an Agent to</span>
        {/* Every phrase is stacked in one grid cell, so the cell is always as big as the
            longest one and swapping phrases never reflows the page. Screen readers get the
            stable summary instead of a sentence that changes under them. */}
        <span className={css.asks} aria-hidden="true">
          {AGENT_ASKS.map((ask, i) => (
            <em key={ask} className={classNames(css.ask, { [css.askActive]: i === askIndex })}>
              {ask}
            </em>
          ))}
        </span>
        <span className={css.srOnly}> edit your media.</span>
      </h1>
      <p className={css.lede}>
        Bring a single file or your whole library. Agents cut, clip, reframe, edit and caption it
        for you.
      </p>
    </section>
  );
};
